export const getSpacingTop = spacing => {
  if (!spacing) {
    return 0;
  }
  return spacing.top || spacing.vertical || spacing.all || 0;
};
export const getSpacingBottom = spacing => {
  if (!spacing) {
    return 0;
  }
  return spacing.bottom || spacing.vertical || spacing.all || 0;
};
export const getSpacingLeft = spacing => {
  if (!spacing) {
    return 0;
  }
  return spacing.left || spacing.horizontal || spacing.all || 0;
};
export const getSpacingRight = spacing => {
  if (!spacing) {
    return 0;
  }
  return spacing.right || spacing.horizontal || spacing.all || 0;
};